import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenVaccinationsIndicatorC2Data } from "@/services/esus/indicator/esf/c2/getDetailedCitizensVaccinationsIndicatorC2";

import { IndicatorEsfC2CitizensVaccinationsHistoryInfo } from "./IndicatorEsfC2CitizensVaccinationsHistoryInfo";
import { VaccinationCard } from "@/components/VaccinationCard";

type IndicatorEsfC2CitizensVaccinationsHistoryProps = {
	citizenWithVaccinations: DetailedCitizenVaccinationsIndicatorC2Data;
};

export function IndicatorEsfC2CitizensVaccinationsHistory({
	citizenWithVaccinations,
}: Readonly<IndicatorEsfC2CitizensVaccinationsHistoryProps>) {
	const indicatorEsfC2CitizensVaccinationsHistoryInfo = {
		fullName: citizenWithVaccinations.fullName ? citizenWithVaccinations.fullName : "N/A",
		birthdate: citizenWithVaccinations.birthdate
			? dayjs(citizenWithVaccinations.birthdate).format("DD/MM/YYYY")
			: "N/A",
		document: citizenWithVaccinations.cpf
			? formatIdentifier(citizenWithVaccinations.cpf)
			: citizenWithVaccinations.cns ?? "",
		motherName: citizenWithVaccinations.motherName ?? "",
		phone: citizenWithVaccinations.phone ? phoneFormat(citizenWithVaccinations.phone) : "",
		address:
			addressConcat(
				citizenWithVaccinations.street,
				citizenWithVaccinations.houseNumber,
				citizenWithVaccinations.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC2CitizensVaccinationsHistoryInfo
				{...indicatorEsfC2CitizensVaccinationsHistoryInfo}
			/>
			<VaccinationCard
				vaccinations={(citizenWithVaccinations.vaccines ?? []).map((vaccine) => {
					return {
						id: vaccine.id,
						dateofVaccine: dayjs(vaccine.dateofVaccine).format("DD/MM/YYYY"),
						immunobiological: vaccine.immunobiological,
						immunobiologicalDosage: vaccine.immunobiologicalDosage,
						professional: vaccine.professional,
						healthTeam: vaccine.healthTeam,
						healthUnit: vaccine.healthUnit,
						status: "vaccinated",
						healthTeamId: vaccine.healthTeamId,
						healthUnitId: vaccine.healthUnitId,
					};
				})}
			/>
		</>
	);
}
